{{each data}}
<li>
    <div class="li-top">
        <a href="/user/index?uid={{$value.uid}}"><img src="{{$value.avatar}}" alt="" class="auth-img"></a>
        <div class="auth-content">
            <p class="auth-name">{{$value.real_name}}</p>
            {{if $value.is_admin == 1}}
            <span class="admin">管理员</span>
            {{/if}}
            <p class="auth-">{{$value.career}}</p>
        </div>
    </div>
    <div class="auth-btn-box">
        <a href="/user/article?uid={{$value.uid}}" class="">文章 <b>{{$value.article_count}}</b></a>
        <a href="/user/index?uid={{$value.uid}}" class="">动态 <b>{{$value.dynamic_count}}</b></a>
    </div>
</li>
{{/each}}